import React, { useEffect, useState } from 'react';
import { Checkbox, Input, Modal, Radio, Select, TimePicker, Typography, DatePicker, Drawer, Row, Col } from 'antd';
import ic_file_eadd from "../../../Assets/images/ic_file_eadd.svg"
import { CalendarOutlined, FieldTimeOutlined, InboxOutlined, LockFilled, LockOutlined, SearchOutlined } from '@ant-design/icons';
import { setAnnouncementData, postAnnouncementData, setAnnounceKey, setDraftPage, setSchedulePage, storeAnnouncePage } from 'actions/announcement';
import { message, Upload } from 'antd';
import Xmark from '../../../Assets/common/Xmark.svg'
import { Notification } from "services";
import downArrow from '../../../Assets/common/downArrow.svg'

import { connect } from 'react-redux';

// import DatePicker from 'pages/care/datePicker';
import moment from 'moment';
import AnimatedTextField from 'components/AnimatedTextField';
import { getAutocompleteSearchForNotification, getCourseDashboardData, getCoursesCategoriesForNotifications, getCoursesSubCategoriesForNotification } from 'actions/courseManagement';
import { fetchClassList } from 'actions/schedule';
import AnimatedDatePicker from 'components/AnimatedDatePicker';
import AnimatedTimePicker from 'components/AnimatedTimePicker';
import { Button } from 'components/Button';
// import { setKey } from 'actions/digitalLibrary';
const { Text } = Typography
const { Option } = Select

const { Dragger } = Upload;
const calenderIcon = <CalendarOutlined style={{ color: "#1089FF" }} />
const timeIcon = <FieldTimeOutlined style={{ color: "#1089FF" }} />


const CreateAnnouncementModal = ({ fetchAnnouncement, SetKey, standardList, isAnnouncement, setIsAnnouncement, close, storeAnnouncementData, setAnnouncementData, postAnnouncementData, key, setAnnounceKey, togglePageLoader, storeKey, setDraftPage, setSchedulePage, storeAnnouncePage,
    courseCategoryData, courseSubCategoriesData, autocompleteSearchData, classList, getAutocompleteSearchForNotification, getCoursesCategoriesForNotifications, getCoursesSubCategoriesForNotification, fetchClassList, getCourseDashboardData, courseDashboardData
}) => {
    console.log("AA-storeAnnouncementData", storeKey);
    const [isSelectValue, setIsSelectValue] = useState('All')
    const [classListShow, setClassListShow] = useState(true)
    const [date, setDate] = useState(moment().format('YYYY-MM-DD'))
    const [time, setTime] = useState(moment().format('hh:mm '))
    const [file, setfile] = useState([])
    const [check, setCheck] = useState(false)
    const [isDraftLoader, setIsDraftLoader] = useState(false)
    const [isAnnouncementLoader, setIsAnnouncementLoader] = useState(false)
    const [scheduleLoader, setSchedulerLoader] = useState(false)

    const [std, setStd] = useState([])
    const [type, setType] = useState("")


    const [image, setImage] = useState(null)
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [previewTitle, setPreviewTitle] = useState('');
    const [isDisable, setIsDisable] = useState(false)
    const [studentsType, setStudentsType] = useState('allStudents')
    const [checkedItems, setCheckedItems] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState([]);
    const [selectedSubCategory, setSelectedSubCategory] = useState([]);
    const [selectedCourses, setSelectedCourses] = useState([]);
    const [selectedBatches, setSelectedBatches] = useState([]);
    const [updatedClassList, setUpdatedClassList] = useState([]);

    useEffect(() => {
        getCoursesCategoriesForNotifications()
        getCoursesSubCategoriesForNotification()
        getAutocompleteSearchForNotification(null, () => { })
        fetchClassList('', null)
        getCourseDashboardData(() => { })
    }, [])
    useEffect(() => {
        if (classList) {
            setUpdatedClassList(classList.map(({ section, std, ...rest }) => ({
                ...rest,
                name: `${std} - ${section}` // Rename 'section' to 'name'
            })))
        }
    }, [classList])

    useEffect(() => { setDate(''), setTime('') }, [])
    const options = [
        courseDashboardData?.overview?.some(item => item?.overviewType == "liveCourse") && { label: "Live courses", value: "course" },
        courseDashboardData?.overview?.some(item => item?.overviewType == "videoResource") && { label: "Video resources", value: "videoResource" },
        courseDashboardData?.overview?.some(item => item?.overviewType == "testSeries") && { label: "Online test series", value: "testSeries" },
        courseDashboardData?.overview?.some(item => item?.overviewType == "studyMaterial") && { label: "Study materials", value: "studyMaterial" },

    ].filter(Boolean);

    const handleChange = (checkedValues) => {
        setCheckedItems(checkedValues);
    };

    const handleChangeCategories = (value) => {
        const selectedCourse = courseCategoryData.find(course => course.id === value);
        if (selectedCourse) {
            const isAlreadySelected = selectedCategory.some(course => course.id === value);
            if (!isAlreadySelected) {
                setSelectedCategory(prevCourses => [...prevCourses, selectedCourse]);
            }
        }
    };
    const handleChangeSubCategories = (value) => {
        const selectedCourse = courseSubCategoriesData.find(course => course.id === value);
        if (selectedCourse) {
            const isAlreadySelected = selectedSubCategory.some(course => course.id === value);
            if (!isAlreadySelected) {
                setSelectedSubCategory(prevCourses => [...prevCourses, selectedCourse]);
            }
        }
    };
    const handleChangeCourses = (value) => {
        const selectedCourse = autocompleteSearchData.find(course => course.id === value);
        if (selectedCourse) {
            const isAlreadySelected = selectedCourses.some(course => course.id === value);
            if (!isAlreadySelected) {
                setSelectedCourses(prevCourses => [...prevCourses, selectedCourse]);
            }
        }
    };

    const handleChangeBatches = (value) => {
        const selectedCourse = updatedClassList.find(course => course.id === value);
        if (selectedCourse) {
            const isAlreadySelected = selectedBatches.some(course => course.id === value);
            if (!isAlreadySelected) {
                setSelectedBatches(prevCourses => [...prevCourses, selectedCourse]);
            }
        }
    };

    const handleRemoveCategory = (courseId) => {
        setSelectedCategory(selectedCategory.filter(course => course.id !== courseId));
    };

    const handleRemoveSubCategory = (courseId) => {
        setSelectedSubCategory(selectedSubCategory.filter(course => course.id !== courseId));
    };

    const handleRemoveCourses = (courseId) => {
        setSelectedCourses(selectedCourses.filter(course => course.id !== courseId));
    };
    const handleRemoveBatches = (courseId) => {
        setSelectedBatches(selectedBatches.filter(course => course.id !== courseId));
    };

    const showModal = () => {
        setIsAnnouncement(true);
    };

    const handleCancel = () => {
        // setDescriptionLength(null)
        setAnnouncementData('')
        // setDescription('')
        // setTarget('')
        setIsSelectValue('')
        setDate('')
        setTime('')
        setIsAnnouncement(false);


    };
    function handleRemove(info) {
        let temp = []
        for (let i = 0; i < file.length; i++) {
            if (file[i].uid !== info) {
                temp.push(file[i])
            }
        }
        setfile([...temp]);

    }
    const getBase64 = (img, callback) => {
        const reader = new FileReader();
        reader.addEventListener("load", () => callback(reader.result));
        reader.readAsDataURL(img);
    };
    const handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || file.preview);
        setPreviewOpen(true);
        setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
    };
    const fileSizeLimit = 10 * 1024 * 1024

    const props = {
        name: 'file',
        multiple: false,
        customRequest({ onSuccess }) {
            setTimeout(() => onSuccess('ok'), 0);
        },
        onPreview() { handlePreview },
        onChange(info) {
            console.log("AAA-fileSizeLimit", fileSizeLimit, info);

            const { status } = info.file;

            if (info.file.status === 'uploading') {
                return
            }
            if (info.file.status === "done" || info.file.status === "error") {
                const fileExtension = info.file.name ? info.file.name.split('.').pop().toLowerCase() : '';
                const isImage = ['png', 'jpg', 'jpeg'].includes(fileExtension);
                const currentLimit = isImage ? 5 * 1024 * 1024 : 10 * 1024 * 1024;
                if (info.file.size > currentLimit) {
                    Notification.error('Error', isImage ? 'Image size exceeds the limit of 5MB.' : 'File size exceeds the limit of 10MB.');
                    return;
                } else {
                    getBase64(info.file.originFileObj, (imageUrl) => {
                        setfile([...file, info.file.originFileObj])
                    })
                }

            }
        },
        onDrop(e) {
        },
        beforeUpload(file) {
            const allowedExtensions = ['doc', 'docx', 'xls', 'xlsx', 'pdf', 'png', 'jpg', 'jpeg'];
            const fileExtension = file.name.split('.').pop().toLowerCase();
            if (!allowedExtensions.includes(fileExtension)) {
                Notification.error('Error', 'Only doc, xlsx, pdf, png, jpg files are supported!');
                return Upload.LIST_IGNORE;
            }
            const isImage = ['png', 'jpg', 'jpeg'].includes(fileExtension);
            if (isImage && file.size > 5 * 1024 * 1024) {
                Notification.error('Error', 'Image size exceeds the limit of 5MB.');
                return Upload.LIST_IGNORE;
            }
            if (!isImage && file.size > 10 * 1024 * 1024) {
                Notification.error('Error', 'File size exceeds the limit of 10MB.');
                return Upload.LIST_IGNORE;
            }
            return true;
        },
        onRemove(info, index) {
            handleRemove(info.uid);
        }

    };
    useEffect(() => {

        if (std[0] != undefined || std[0] != -1) {
            console.log("AAA-std1", std?.length, standardList.length);
            if (std?.length == standardList.length) {
                setClassListShow(false)
                setStd([-1])
            }
        }

    }, [std?.length])


    const handleClass = (e, obj) => {
        console.log("AA-e", e);
        // setSelectClass(true)
        if (e.includes(-1)) {
            setClassListShow(false)
            setStd([-1])
        }
        else if (!e.length == 0) {
            setStd(e)
        }
        else {
            setStd(e)
            setClassListShow(true)
        }
    }
    const onSelect = (value, obj) => {
        if (value == -1) {
            setStd([-1])
        }
    }
    const onChangeCheckBox = (e) => {
        if(!e.target.checked){
            setDate('')
            setTime('')
        }
        setCheck(e.target.checked)
        
    }
    const handleDate = (date, dateString) => {
        setDate(dateString)
        setIsDisable(true)
    }

    const handleTime = (time, timeString) => {
        setTime(moment(timeString, "hh:mm A").format("HH:mm"));
    }
    const disabledStartTimeHours = () => {
        const hours = [];
        if (date && moment(date, ['DD/MM/YYYY', 'YYYY-MM-DD']).isSame(moment(), 'day')) {
            const minAllowedTime = moment().add(10, 'minutes');
            for (var i = 0; i < minAllowedTime.hour(); i++) {
                hours.push(i);
            }
        }
        return hours;
    };
    const disabledStartTimeMinutes = (selectedHour) => {
        var minutes = [];
        if (date && moment(date, ['DD/MM/YYYY', 'YYYY-MM-DD']).isSame(moment(), 'day')) {
            const minAllowedTime = moment().add(10, 'minutes');
            if (selectedHour === minAllowedTime.hour()) {
                for (var i = 0; i < minAllowedTime.minute(); i++) {
                    minutes.push(i);
                }
            } else if (selectedHour < minAllowedTime.hour()) {
                for (var i = 0; i < 60; i++) {
                    minutes.push(i);
                }
            }
        }
        return minutes;
    }
    const disabledDate = (current) => {
        // Can not select days before today and today
        return current && current < moment().startOf('day');
    }
    return (
        <>

            <Drawer
                // className="viewAnnouncement"
                visible={isAnnouncement}
                //centered={true}
                width={"500px"}
                closable={false}
                // bodyStyle={{ height: "500px" }}
                onClose={() => handleCancel()}
            >
                <div className='scroll-bar-universal' style={{ height: '90%' }}>
                    <div style={{ padding: '0px 20px', display: 'flex', justifyContent: 'space-between', marginTop: 10 }}>
                        <div style={{ fontWeight: 'bold', fontSize: '20px', color: '#191919', fontFamily: 'Roboto, sans-serif' }}>Create an announcement </div>
                        <div onClick={() => handleCancel()}><img style={{ height: 16, width: 16, cursor: 'pointer' }} src={Xmark} /></div>
                    </div>
                    <div style={{ padding: '0px 20px' }}>
                        <AnimatedTextField
                            label="Title"
                            isMandatory={true}
                            inputId="title-name"
                            value={storeAnnouncementData ? storeAnnouncementData : ''}
                            handleInputChange={(e) => {
                                setAnnouncementData(e.target.value)
                            }}
                        />
                    </div>

                    <div style={{ marginTop: "20px", padding: '5px 20px' }}>
                        <div style={{ fontFamily: 'roboto', color: '#AEAEAE' }}>Attachments<span style={{ color: '#ff414d' }}>*</span></div>
                        <Dragger
                            {...props}
                            maxCount={1}
                            disabled={file.length > 0}
                            className={file.length > 0 ? "disabled-drag-box" : ""}
                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.xsl,.pdf,.doc,.docx,.jpg,.jpeg,.png" listType="picture" style={{ borderColor: "#1089FF" }}>
                            <div className="ant-upload-drag-icon">
                                <img src={ic_file_eadd} />
                            </div>
                            <div style={{ display: "flex", justifyContent: "center" }}>
                                <div className="ant-upload-text" style={{ color: "#AEAEAE", fontSize: "13px", fontWeight: "bold" }}>Drop file here or</div>
                                <div className="ant-upload-hint" style={{ color: "#1089FF", fontSize: "13px", fontWeight: "bold", marginLeft: "5px" }}>
                                    Click to Upload
                                </div>
                            </div>
                            <div style={{ color: '#AEAEAE', fontSize: '11px', marginTop: '6px' }}>
                                Only (doc, xlsx, pdf, png, jpg, etc.) supported
                            </div>
                        </Dragger>
                    </div>






                    <div style={{ display: 'flex', width: '100%', marginTop: 20, padding: '5px 20px', }}>

                        <div style={{ width: '50%' }}>
                            <div style={{ color: '#aeaeae', fontSize: 14, }}>Target <span style={{ color: '#ff414d' }}>*</span></div>
                            <div style={{ marginLeft: -8, marginTop: -5, }}>
                                <Select
                                    bordered={null}
                                    getPopupContainer={(trigger) => trigger.parentElement}
                                    value={isSelectValue !== '' ? isSelectValue : null}
                                    onChange={(e) => {
                                        setIsSelectValue(e)
                                        setStudentsType('allStudents')
                                        setSelectedBatches([])
                                        setSelectedCourses([])
                                        setSelectedCategory([])
                                        setSelectedSubCategory([])
                                        setCheckedItems([])
                                    }}
                                    style={{ width: '98%' }}
                                    suffixIcon={<img src={downArrow} alt="custom icon" style={{ width: 16, height: 16 }} />}
                                >
                                    <Option value={'All'}>All</Option>
                                    <Option value={'Teacher'}>Teacher</Option>
                                    <Option value={'Student'}>Student</Option>
                                    <Option value={'Data Operator'}>Data Operator</Option>
                                    <Option value={'Operation'}>Operations</Option>
                                </Select>
                            </div>
                            <div style={{ borderBottom: '1px solid #d7d7d7', marginLeft: 5, width: '92%', }}></div>
                        </div>
                        {isSelectValue == 'Student' ?
                            <div style={{ width: '50%', marginLeft: '6%' }}>
                                <div style={{ color: '#aeaeae', fontSize: 14, }}>Select a student group <span style={{ color: '#ff414d' }}>*</span></div>
                                <div style={{ marginLeft: -10, marginTop: -5 }}>
                                    <Select
                                        bordered={null}
                                        // placeholder="Select plan"
                                        getPopupContainer={(trigger) => trigger.parentElement}
                                        value={studentsType}
                                        onChange={(e) => {
                                            setStudentsType(e)
                                        }}
                                        style={{ width: '98%' }}
                                        suffixIcon={<img src={downArrow} alt="custom icon1" style={{ width: 16, height: 16 }} />}
                                    >
                                        <Option value="allStudents">All students</Option>
                                        <Option value="batch">Batch</Option>
                                        <Option value="course">Course</Option>
                                        <Option value="courseType">Course type</Option>
                                        <Option value="courseCategory">Course category</Option>
                                        <Option value="courseSubcategory">Course subcategory</Option>
                                    </Select>
                                </div>
                                <div style={{ borderBottom: '1px solid #d7d7d7', marginLeft: 2, width: '92%', }}></div>
                            </div>
                            : null}
                    </div>

                    {
                        isSelectValue == 'Student' && studentsType == 'courseType' ?
                            <div style={{ marginLeft: 25, marginTop: 20, width: '90%' }}>
                                <Checkbox.Group value={checkedItems} onChange={handleChange}>
                                    <Row gutter={[20, 10]} style={{ fontFamily: "Roboto, sans-serif" }}>
                                        {options.map((option) => (
                                            <Col key={option.value} xs={24} sm={12} md={12}> {/* 2 items per row */}
                                                <Checkbox
                                                    value={option.value}
                                                    style={{
                                                        color: "#636363",
                                                        fontSize: 16,
                                                        width: 200
                                                    }}
                                                >
                                                    {option.label}
                                                </Checkbox>
                                            </Col>
                                        ))}
                                    </Row>
                                </Checkbox.Group>
                            </div>
                            :
                            isSelectValue == 'Student' && studentsType == 'courseCategory'
                                ?
                                <div style={{ marginTop: 20 }}>
                                    <div style={{ color: '#aeaeae', fontSize: 14, padding: '0px 20px' }}>Select course categories <span style={{ color: '#ff414d' }}>*</span></div>
                                    <div style={{ marginLeft: 8, marginTop: -5 }}>
                                        <Select
                                            bordered={null}
                                            showSearch={true}
                                            placeholder={
                                                <span style={{ marginLeft: -10, position: 'absolute', zIndex: 1 }}>
                                                    <SearchOutlined style={{ marginRight: 8, color: "#aeaeae" }} />
                                                    Sample: Marketing, Cloud computing etc.
                                                </span>
                                            }

                                            onChange={(value) => {
                                                handleChangeCategories(value);
                                            }}
                                            style={{ width: '98%' }}
                                            suffixIcon={<img src={downArrow} alt="custom icon" style={{ width: 16, height: 16 }} />}
                                            value={null}
                                            filterOption={(input, option) => {
                                                // Case-insensitive search
                                                return option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                            }}
                                            // Optional: customize the no-match message
                                            notFoundContent="No matching category found"
                                        >
                                            {courseCategoryData.map((course) => {
                                                const isSelected = selectedCategory.some(selected => selected.id === course.id);
                                                return (
                                                    <Option
                                                        key={course.id}
                                                        value={course.id}
                                                        style={{
                                                            backgroundColor: isSelected ? '#dacff2' : 'transparent',
                                                            fontWeight: isSelected ? '500' : 'normal',
                                                            borderRadius: 5,

                                                        }}
                                                    >
                                                        {course.name}
                                                    </Option>
                                                );
                                            })}
                                        </Select>
                                    </div>
                                    <div style={{ borderBottom: '1px solid #d7d7d7', marginLeft: 18, width: '92%', }}></div>
                                    <div className="selected-courses">
                                        {selectedCategory.map((course) => (
                                            <div key={course.id} className="course-tag">
                                                {course.name}
                                                <span
                                                    className="remove-icon"
                                                    onClick={() => handleRemoveCategory(course.id)}
                                                >
                                                    <img style={{ width: 12, height: 12, marginTop: -6 }} src={Xmark} />
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                :
                                isSelectValue == 'Student' && studentsType == 'courseSubcategory'
                                    ?
                                    <div style={{ marginTop: 20 }}>
                                        <div style={{ color: '#aeaeae', fontSize: 14, padding: '0px 20px' }}>Select course subcategory <span style={{ color: '#ff414d' }}>*</span></div>
                                        <div style={{ marginLeft: 8, marginTop: -5 }}>
                                            <Select
                                                bordered={null}
                                                showSearch={true}
                                                placeholder={
                                                    <span style={{ marginLeft: -10, position: 'absolute', zIndex: 1 }}>
                                                        <SearchOutlined style={{ marginRight: 8, color: "#aeaeae" }} />
                                                        Sample: Marketing, Cloud computing etc.
                                                    </span>
                                                }

                                                onChange={(value) => {
                                                    console.log("Select changed:", value);
                                                    handleChangeSubCategories(value);
                                                }}
                                                style={{ width: '98%' }}
                                                suffixIcon={<img src={downArrow} alt="custom icon" style={{ width: 16, height: 16 }} />}
                                                value={null}
                                                filterOption={(input, option) => {
                                                    // Case-insensitive search
                                                    return option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                                }}
                                                // Optional: customize the no-match message
                                                notFoundContent="No matching subcategoryy found"
                                            >
                                                {courseSubCategoriesData.map((course) => {
                                                    const isSelected = selectedSubCategory.some(selected => selected.id === course.id);
                                                    return (
                                                        <Option
                                                            key={course.id}
                                                            value={course.id}
                                                            style={{
                                                                backgroundColor: isSelected ? '#dacff2' : 'transparent',
                                                                fontWeight: isSelected ? '500' : 'normal',
                                                                borderRadius: 5,

                                                            }}
                                                        >
                                                            {course.name}
                                                        </Option>
                                                    );
                                                })}
                                            </Select>
                                        </div>
                                        <div style={{ borderBottom: '1px solid #d7d7d7', marginLeft: 18, width: '92%', }}></div>
                                        <div className="selected-courses">
                                            {selectedSubCategory.map((course) => (
                                                <div key={course.id} className="course-tag">
                                                    {course.name}
                                                    <span
                                                        className="remove-icon"
                                                        onClick={() => handleRemoveSubCategory(course.id)}
                                                    >
                                                        <img style={{ width: 12, height: 12, marginTop: -6 }} src={Xmark} />
                                                    </span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    :

                                    isSelectValue == 'Student' && studentsType == 'course'
                                        ?
                                        <div style={{ marginTop: 20 }}>
                                            <div style={{ color: '#aeaeae', fontSize: 14, padding: '0px 20px' }}>Select course name <span style={{ color: '#ff414d' }}>*</span></div>
                                            <div style={{ marginLeft: 8, marginTop: -5 }}>
                                                <Select
                                                    bordered={null}
                                                    showSearch={true}
                                                    placeholder={
                                                        <span style={{ marginLeft: -10, position: 'absolute', zIndex: 1 }}>
                                                            <SearchOutlined style={{ marginRight: 8, color: "#aeaeae" }} />
                                                            Sample: JEE main 2025 etc.
                                                        </span>
                                                    }

                                                    onChange={(value) => {
                                                        handleChangeCourses(value);
                                                    }}
                                                    style={{ width: '98%' }}
                                                    suffixIcon={<img src={downArrow} alt="custom icon" style={{ width: 16, height: 16 }} />}
                                                    value={null}
                                                    filterOption={(input, option) => {
                                                        // Case-insensitive search
                                                        return option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                                    }}
                                                    // Optional: customize the no-match message
                                                    notFoundContent="No matching course found"
                                                >
                                                    {autocompleteSearchData.map((course) => {
                                                        const isSelected = selectedCourses.some(selected => selected.id === course.id);
                                                        return (
                                                            <Option
                                                                key={course.id}
                                                                value={course.id}
                                                                style={{
                                                                    backgroundColor: isSelected ? '#dacff2' : 'transparent',
                                                                    fontWeight: isSelected ? '500' : 'normal',
                                                                    borderRadius: 5,

                                                                }}
                                                            >
                                                                {course.name}
                                                            </Option>
                                                        );
                                                    })}
                                                </Select>
                                            </div>
                                            <div style={{ borderBottom: '1px solid #d7d7d7', marginLeft: 18, width: '92%', }}></div>
                                            <div className="selected-courses">
                                                {selectedCourses.map((course) => (
                                                    <div key={course.id} className="course-tag">
                                                        {course.name}
                                                        <span
                                                            className="remove-icon"
                                                            onClick={() => handleRemoveCourses(course.id)}
                                                        >
                                                            <img style={{ width: 12, height: 12, marginTop: -6 }} src={Xmark} />
                                                        </span>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        :
                                        isSelectValue == 'Student' && studentsType == 'batch'
                                            ?
                                            <div style={{ marginTop: 20 }}>
                                                <div style={{ color: '#aeaeae', fontSize: 14, padding: '0px 20px' }}>Select batch <span style={{ color: '#ff414d' }}>*</span></div>
                                                <div style={{ marginLeft: 8, marginTop: -5 }}>
                                                    <Select
                                                        bordered={null}
                                                        showSearch={true}
                                                        placeholder={
                                                            <span style={{ marginLeft: -10, position: 'absolute', zIndex: 1 }}>
                                                                <SearchOutlined style={{ marginRight: 8, color: "#aeaeae" }} />
                                                                Sample: JEE batch 2025 etc.
                                                            </span>
                                                        }

                                                        onChange={(value) => {
                                                            handleChangeBatches(value);
                                                        }}
                                                        style={{ width: '98%' }}
                                                        suffixIcon={<img src={downArrow} alt="custom icon" style={{ width: 16, height: 16 }} />}
                                                        value={null}
                                                        filterOption={(input, option) => {
                                                            // Case-insensitive search
                                                            return option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                                        }}
                                                        // Optional: customize the no-match message
                                                        notFoundContent="No matching batch found"
                                                    >
                                                        {updatedClassList.map((course) => {
                                                            const isSelected = selectedBatches.some(selected => selected.id === course.id);
                                                            return (
                                                                <Option
                                                                    key={course.id}
                                                                    value={course.id}
                                                                    style={{
                                                                        backgroundColor: isSelected ? '#dacff2' : 'transparent',
                                                                        fontWeight: isSelected ? '500' : 'normal',
                                                                        borderRadius: 5,

                                                                    }}
                                                                >
                                                                    {course.name}
                                                                </Option>
                                                            );
                                                        })}
                                                    </Select>
                                                </div>
                                                <div style={{ borderBottom: '1px solid #d7d7d7', marginLeft: 18, width: '92%', }}></div>
                                                <div className="selected-courses">
                                                    {selectedBatches.map((course) => (
                                                        <div key={course.id} className="course-tag">
                                                            {course.name}
                                                            <span
                                                                className="remove-icon"
                                                                onClick={() => handleRemoveBatches(course.id)}
                                                            >
                                                                <img style={{ width: 12, height: 12, marginTop: -6 }} src={Xmark} />
                                                            </span>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                            :
                                            <></>
                    }
                    <div>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 20, marginLeft: 20 }}>
                            <Checkbox style={{ padding: '5px' }} checked={check} onChange={(e) => { onChangeCheckBox(e) }}>Schedule for Later </Checkbox>
                        </div>
                        {check ?
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: 25, gap: 70 }}>
                                <div style={{ width: '40%', display: 'flex', flexDirection: 'column' }}>
                                    <AnimatedDatePicker
                                        inputReadOnly={true}
                                        inputId={`${1001}`}
                                        label="Schedule date"
                                        // isMandatory={true}
                                        value={date ? date : ''}
                                        handleDateChange={handleDate}
                                        // allowClear={true}
                                        disabledDate={disabledDate}
                                    />

                                </div>
                                <div style={{ width: '40%', display: 'flex', flexDirection: 'column' }}>

                                    <AnimatedTimePicker
                                        inputReadOnly={true}
                                        inputId={`start-time-${10001}`}
                                        label="Start time"
                                        // isMandatory={true}
                                        value={time ? moment(time, 'HH:mm') : ''}
                                        handleTimeChange={handleTime}
                                        allowClear={false}
                                        format="hh:mm A"
                                        disabledHours={disabledStartTimeHours}
                                        disabledMinutes={disabledStartTimeMinutes}
                                        disabled={!date}
                                    />

                                </div>
                            </div>
                            : null}
                    </div>

                </div>

                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "20px",
                        padding: '0px 20px'
                    }}
                >
                    <div>
                        <Button
                            loading={isDraftLoader}
                            disabled={(isSelectValue == '' || storeAnnouncementData == undefined || storeAnnouncementData?.trim()?.length == 0 || file?.length == 0)}
                            type='cancel'
                            onClick={() => {
                                let object = {}
                                object.courseItems = studentsType == 'course' ? selectedCourses?.map(item => ({
                                    id: item.itemId,
                                    resourceType: item.itemType
                                })) : [];

                                object.standardIds = studentsType == 'batch' ? selectedBatches?.map(item => item.id) : [];
                                object.categoryIds = studentsType == 'courseCategory' ? selectedCategory?.map(item => item.id) : [];
                                object.subcategoryIds = studentsType == 'courseSubcategory' ? selectedSubCategory?.map(item => item.id) : [];
                                object.courseTypes = studentsType == 'courseType' ? checkedItems : [];
                                object.subtarget = isSelectValue == 'Student' ? studentsType == 'course' ? 'courses' : studentsType == 'batch' ? 'standard' : studentsType == 'courseCategory' ? 'category' :
                                studentsType == 'courseSubcategory' ? 'subcategory' : studentsType == 'courseType' ? 'courseType' : null : undefined
                    

                                setIsDraftLoader(true)
                                postAnnouncementData(isSelectValue, std, "DRAFT", check && date ? moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD') : null, check ? time : null, file, object,
                                    () => {
                                        setIsDraftLoader(false)
                                    },
                                    () => {
                                        setAnnounceKey('1')
                                        setDraftPage(1)
                                        setIsAnnouncement(false);
                                        togglePageLoader(true)
                                        fetchAnnouncement('', '', () => togglePageLoader(false))
                                    })
                            }}
                        >
                            SAVE AS DRAFT
                        </Button>
                    </div>
                    {check !== true ?
                        <div>
                            <Button
                                loading={isAnnouncementLoader}
                                disabled={isSelectValue == '' || storeAnnouncementData == undefined || storeAnnouncementData?.trim().length == 0 || file?.length == 0}
                                type='primary'

                                onClick={() => {
                                    let object = {}
                                    object.courseItems = studentsType == 'course' ? selectedCourses?.map(item => ({
                                        id: item.itemId,
                                        resourceType: item.itemType
                                    })) : [];
                       
                                    object.standardIds = studentsType == 'batch' ? selectedBatches?.map(item => item.id) : [];
                                    object.categoryIds = studentsType == 'courseCategory' ? selectedCategory?.map(item => item.id) : [];
                                    object.subcategoryIds = studentsType == 'courseSubcategory' ? selectedSubCategory?.map(item => item.id) : [];
                                    object.courseTypes = studentsType == 'courseType' ? checkedItems : [];
                                    object.subtarget = isSelectValue == 'Student' ? studentsType == 'course' ? 'courses' : studentsType == 'batch' ? 'standard' : studentsType == 'courseCategory' ? 'category' :
                                    studentsType == 'courseSubcategory' ? 'subcategory' : studentsType == 'courseType' ? 'courseType' : null : undefined
                                
                                    setIsAnnouncementLoader(true)
                                    postAnnouncementData(isSelectValue, std, "ANNOUNCENOW", check && date ? moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD') : null, check ? time : null, file, object,
                                        () => {
                                            setIsAnnouncementLoader(false)


                                        },

                                        () => {
                                            setAnnounceKey('3')

                                            storeAnnouncePage(1)
                                            setIsAnnouncement(false);

                                            togglePageLoader(true)
                                            fetchAnnouncement('', '', () => togglePageLoader(false))
                                        })

                                }}
                            >
                                ANNOUNCE NOW
                            </Button>

                        </div> :
                        <div>
                            {console.log("SS-time", time)}
                            <Button
                                loading={scheduleLoader}
                                disabled={isSelectValue == '' || time == '' || date == '' || storeAnnouncementData == undefined || storeAnnouncementData?.trim().length == 0 || file?.length == 0 || time === '' || date === ""}
                                type='primary'
                                onClick={() => {
                                    let object = {}
                                    object.courseItems = studentsType == 'course' ? selectedCourses?.map(item => ({
                                        id: item.itemId,
                                        resourceType: item.itemType
                                    })) : [];

                                    object.standardIds = studentsType == 'batch' ? selectedBatches?.map(item => item.id) : [];
                                    object.categoryIds = studentsType == 'courseCategory' ? selectedCategory?.map(item => item.id) : [];
                                    object.subcategoryIds = studentsType == 'courseSubcategory' ? selectedSubCategory?.map(item => item.id) : [];
                                    object.courseTypes = studentsType == 'courseType' ? checkedItems : [];
                                    object.subtarget = isSelectValue == 'Student' ?  studentsType == 'course' ? 'courses' : studentsType == 'batch' ? 'standard' : studentsType == 'courseCategory' ? 'category' :
                                    studentsType == 'courseSubcategory' ? 'subcategory' : studentsType == 'courseType' ? 'courseType' : null : undefined


                                    setSchedulerLoader(true)
                                    postAnnouncementData(isSelectValue, std, "SCHEDULE", moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD'), time, file, object,
                                        () => {
                                            // setIsAnnouncement(false);
                                            setSchedulerLoader(false)
                                        },
                                        () => {
                                            setAnnounceKey('2')

                                            setSchedulePage(1)
                                            setIsAnnouncement(false);
                                            togglePageLoader(true)
                                            fetchAnnouncement('', '', () => togglePageLoader(false))
                                        }
                                    )
                                }}

                            >
                                SCHEDULE
                            </Button>

                        </div>}

                </div>

            </Drawer>
        </>
    );
};
const mapStateToProps = (state) => {
    const {
        storeAnnouncementData, standardList, storeKey } = state.announcement;
    const { courseCategoryData, courseSubCategoriesData, autocompleteSearchData, courseDashboardData } = state.courseManagement
    const { classList } = state.schedule
    return {
        storeAnnouncementData, standardList, storeKey, courseCategoryData, courseSubCategoriesData, autocompleteSearchData, classList, courseDashboardData
    };
};

const mapDispatchToProps = (dispatch) => ({

    setAnnouncementData: (res) => dispatch(setAnnouncementData(res)),
    postAnnouncementData: (isSelectValue, std, type, date, time, file, object,callback, successCallback) => dispatch(postAnnouncementData(isSelectValue, std, type, date, time, file, object, callback, successCallback)),
    // fetchAnnouncement: (search, sort, callback) => dispatch(fetchAnnouncement(search, sort, callback)),
    setAnnounceKey: (val) => dispatch(setAnnounceKey(val)),
    setDraftPage: (res) => dispatch(setDraftPage(res)),
    setSchedulePage: (res) => dispatch(setSchedulePage(res)),
    storeAnnouncePage: (res) => dispatch(storeAnnouncePage(res)),
    getCoursesCategoriesForNotifications: () => dispatch(getCoursesCategoriesForNotifications()),
    getCoursesSubCategoriesForNotification: () => dispatch(getCoursesSubCategoriesForNotification()),
    getAutocompleteSearchForNotification: (search, callBack) => dispatch(getAutocompleteSearchForNotification(search, callBack)),
    fetchClassList: (search, subId, callback) => dispatch(fetchClassList(search, subId, callback)),
    getCourseDashboardData: (callBack) => dispatch(getCourseDashboardData(callBack)),

});

export default connect(
    mapStateToProps,
    mapDispatchToProps

)(CreateAnnouncementModal);